import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import Backend from 'i18next-http-backend';

// Import static translation files
import trTranslation from './locales/tr.json';
import enTranslation from './locales/en.json';
import frTranslation from './locales/fr.json';
import deTranslation from './locales/de.json';
import roTranslation from './locales/ro.json';
import itTranslation from './locales/it.json';

// Static resources for faster loading
const resources = {
    tr: {
        translation: trTranslation
    },
    en: {
        translation: enTranslation
    },
    fr: {
        translation: frTranslation
    },
    de: {
        translation: deTranslation
    },
    ro: {
        translation: roTranslation
    },
    it: {
        translation: itTranslation
    }
};

i18n
    .use(Backend) // Loads translations from files
    .use(LanguageDetector) // Detects user language
    .use(initReactI18next) // Passes i18n down to react-i18next
    .init({
        resources,
        
        // Language detection options
        detection: {
            order: ['localStorage', 'navigator', 'htmlTag'],
            caches: ['localStorage'],
            lookupLocalStorage: 'i18nextLng', // i18next'in kendi key'ini kullan
            checkWhitelist: true
        },

        fallbackLng: 'en', // Default language - fallback to English if translation not found
        debug: false, // Disable debug mode to remove console logs

        interpolation: {
            escapeValue: false, // React already does escaping
        },

        // Backend options for loading translation files
        backend: {
            loadPath: '/locales/{{lng}}.json',
        },

        // React options
        react: {
            useSuspense: false,
        },

        // Namespace options
        ns: ['translation'],
        defaultNS: 'translation',

        // KeySeparator and nsSeparator
        keySeparator: '.',
        nsSeparator: ':',

        // Supported languages
        supportedLngs: ['tr', 'en', 'fr', 'de','ro','it'],
        nonExplicitSupportedLngs: true,
    });

export default i18n; 